(function () {
    'use strict';

    angular
        .module('app.service')
        .factory('pendingUserService', pendingUserService);

    /*jshint -W072 */
    /* @ngInject */
    function pendingUserService($http,
        $q,
        $filter,
        exception,
        logger,
        coreService,
        userApplicationService,
        userRoleService,
        moment,
        config,
        $odataresource,
        $odata, $rootScope,
        ATAC) {
        var service = {
            getDefaultPendingUser: getDefaultPendingUser,
            getODataResource: getODataResource,
            getRolesODataResource: getRolesODataResource,
            getPendingUser: getPendingUser,
            getPendingUsers: getPendingUsers,
            getRejectedCustomers: getRejectedCustomers,
            getProcessedUsers: getProcessedUsers,
            getPendingUsersTableConfig: getPendingUsersTableConfig,
            getPendingUsersCount: getPendingUsersCount,
            getProcessedUsersTableConfig: getProcessedUsersTableConfig,
            processPendingUser: processPendingUser,
            rejectPendingUser: rejectPendingUser,
            getAllPendingRolesByApplication: getAllPendingRolesByApplication,
            getRolesForPendingUser: getRolesForPendingUser,
            getApplicationAccessAndRolesForMasterUser: getApplicationAccessAndRolesForMasterUser
        };

        activate();

        return service;

        function activate() {
        }

        function getStatusBadges() {
            return [{
                id: 1,
                name: 'Pending',
                className: 'badge-unprocessed'
            }, {
                id: 2,
                name: 'Processed',
                className: 'badge-processed'
            }, {
                id: 3,
                name: 'Rejected',
                className: 'badge-rejected'
            }, {
                id: 4,
                name: 'Not Applicable',
                className: 'badge-na'
            }, {
                id: 5,
                name: 'Unprocessed',
                className: 'badge-na'
            }];
        }

        function getStatusTypes() {
            return [
                {
                    ProcessStatusId: 1,
                    Status: 'Pending'
                },
                {
                    ProcessStatusId: 2,
                    Status: 'Processed'
                },
                {
                    ProcessStatusId: 3,
                    Status: 'Rejected'
                },
                {
                    ProcessStatusId: 4,
                    Status: 'Not Applicable'
                },
                {
                    ProcessStatusId: 5,
                    Status: 'Unprocessed'
                }
            ];
        }

        function dropDownStatuses() {
            return getStatusTypes().map(function (statusType) {
                return {
                    value: statusType.ProcessStatusId,
                    name: statusType.Status
                };
            });
        }

        function getDefaultPendingUser() {
            var pendingUser = {
                user:
                {
                    UserId: 0,
                    ConnectionTypeId: 2,
                    Email: '',
                    IsActive: true,
                    FullName: '',
                    AssignedUserId: 0,
                    InviteEmailSent: false,
                    DateCreated: moment().toDate(),
                    UpdatedUserId: 0,
                    DateUpdated: moment().toDate(),
                    Deleted: false,
                    IsAdmin: false
                },
                settings:
                {
                    roleName: 'Corporate',
                    RoleId: 11,
                    CorporateId: 0,
                    RegionId: 0,
                    AreaId: 0,
                    SiteId: 0
                },
                applications: []
            };
            return angular.copy(pendingUser);
        }

        function getODataResource() {
            return $odataresource(config.apiUrl + 'odata/PendingUsers',
                {},
                {},
                {
                    odatakey: 'PendingUserId',
                    isodatav4: true
                });
        }

        function getRolesODataResource() {
            return $odataresource(config.apiUrl + 'odata/PendingUserRoleTies',
                {},
                {},
                {
                    odatakey: 'UserRoleTieId',
                    isodatav4: true
                });
        }

        function getPendingUser(pendingUserId) {
            var user = getODataResource();
            var query = user.odata();
            var processStatusId = 1;

            return query
                .filter('Status/ProcessStatusId', new $odata.Value(parseInt(processStatusId).toString(), 'Int32'))
                .filter('PendingUserId', pendingUserId)
                .expand('Site')
                .expand('Site', 'Country')
                .expand('Site', 'State')
                .expand('UserRoleTies')
                .expand('UserRoleTies', 'Role')
                .expand('UserTruckTie')
                .expand('UserTruckTie', 'Truck')
                .withInlineCount()
                .query()
                .$promise;
        }

        function getPendingUsers(tableState) {
            var processPredicate = new $odata.Predicate('Status/ProcessStatusId', '==',
                    new $odata.Value(parseInt('1').toString(), 'Int32'))
                .and(new $odata.Predicate('StatusSite/ProcessStatusId', '!=',
                    new $odata.Value(parseInt('3').toString(), 'Int32')))
                .and(new $odata.Predicate('Verified', '==', false));

            var verifiedPredicate = new $odata.Predicate(new $odata.Predicate('Verified', '==', true))
                .and('StatusSite/ProcessStatusId', '==',
                    new $odata.Value(parseInt('1').toString(), 'Int32'))
                .and('Status/ProcessStatusId', '==',
                    new $odata.Value(parseInt('1').toString(), 'Int32'));                

            var filterPredicate = new $odata.Predicate.or([processPredicate, verifiedPredicate]);

            return getPendingData(tableState, filterPredicate);
        }

        function getProcessedUsers(tableState) {
            var filterPredicate = new $odata.Predicate.or([
                new $odata.Predicate('Status/ProcessStatusId', '==',
                    new $odata.Value(parseInt('2').toString(), 'Int32')),
                new $odata.Predicate('Status/ProcessStatusId', '==',
                    new $odata.Value(parseInt('3').toString(), 'Int32'))]);

            return getPendingData(tableState, filterPredicate);
        }

        function getRejectedCustomers(tableState) {
            var filterPredicate = new $odata.Predicate.and([
                new $odata.Predicate('Status/ProcessStatusId', '==',
                    new $odata.Value(parseInt('1').toString(), 'Int32')),
                new $odata.Predicate('StatusSite/ProcessStatusId', '==',
                    new $odata.Value(parseInt('3').toString(), 'Int32'))
            ]);

            return getPendingData(tableState, filterPredicate);
        }

        function getPendingData(tableState, filterPredicate) {
            var user = getODataResource();
            var query = user.odata();

            if (!!tableState) {
                coreService.processODataFilters(query, tableState.search.predicateObject,
                    getPendingUsersTableConfig().columns);
                coreService.processODataPage(query, tableState.pagination);
            } else {
                tableState = { sort: {} };
            }
            tableState.sort = tableState.sort.predicate ? tableState.sort : { predicate: 'Email', reverse: false };
            coreService.processODataSort(query, tableState.sort);

            return query
                .filter(filterPredicate)
                .expandPredicate('UserApplicationTies')
                .select('Application')
                .expandPredicate('Application')
                .select('ApplicationId')
                .select('ApplicationName')
                .select('IsLegacy')
                .finish()
                .finish()
                .expandPredicate('UserRoleTies')
                .select('Role')
                .expandPredicate('Role')
                .select('RoleId')
                .select('ApplicationId')
                .finish()
                .finish()
                .withInlineCount()
                .query()
                .$promise
                .then(function (result) {
                    angular.forEach(result, function (legacyUser) {
                        var legacyApplications = [];
                        var userApplications = [];

                        angular.forEach(legacyUser.UserApplicationTies, function (application) {
                            var appRoles = [];
                            angular.forEach(legacyUser.UserRoleTies, function (role) {
                                if (role.Role.ApplicationId === application.Application.ApplicationId) {
                                    appRoles.push(role.Role.RoleId);
                                }
                            });
                            userApplications.push({
                                ApplicationId: application.Application.ApplicationId,
                                Roles: appRoles
                            });
                            if (application.Application.IsLegacy) {
                                legacyApplications.push(application.Application.ApplicationName);
                            }
                        });

                        legacyUser.LegacyApplications = legacyApplications.join(', ');
                        legacyUser.ApplicationRoles = userApplications;
                        legacyUser.CustomerMatch = false;
                        legacyUser.Rejected = legacyUser.UserStatusId === 3;
                        legacyUser.MasterMatch = !!legacyUser.UserId;

                        if (legacyUser.SiteId !== null) {
                            legacyUser.CustomerMatch = true;
                        }
                    });
                    return result;
                }).finally(function () {
                    ATAC.hideLoader();
                });
        }

        function getPendingUsersTableConfig() {
            var tableConfig = {
                columns: [
                    {
                        id: 'FirstName',
                        displayName: 'First Name',
                        ODataKey: 'FirstName',
                        type: 'match'
                    },
                    {
                        id: 'LastName',
                        displayName: 'Last Name',
                        ODataKey: 'LastName',
                        type: 'match'
                    },
                    {
                        id: 'Email',
                        displayName: 'Email',
                        ODataKey: 'Email',
                        type: 'match'
                    },
                    {
                        id: 'SiteStatusId',
                        displayName: 'Customer Status',
                        ODataKey: 'SiteStatusId',
                        type: 'multiBadge',
                        badges: getStatusBadges(),
                        options: dropDownStatuses()
                    },
                    {
                        id: 'MasterMatch',
                        displayName: 'Master Record',
                        ODataKey: 'UserId',
                        type: 'nullable',
                        badge: {
                            on: {
                                className: 'success',
                                display: 'true'
                            },
                            off: {
                                className: 'danger',
                                display: 'false'
                            }
                        }

                    }
                ],
                actions: []
            };
            return tableConfig;
        }

        function getProcessedUsersTableConfig() {
            var tableConfig = {
                columns: [
                    {
                        id: 'FirstName',
                        displayName: 'First Name',
                        ODataKey: 'FirstName',
                        type: 'match'
                    },
                    {
                        id: 'LastName',
                        displayName: 'Last Name',
                        ODataKey: 'LastName',
                        type: 'match'
                    },
                    {
                        id: 'Email',
                        displayName: 'Email',
                        ODataKey: 'Email',
                        type: 'match'
                    },
                    {
                        id: 'Rejected',
                        displayName: 'Status',
                        ODataKey: 'Rejected',
                        type: 'badge',
                        badge: {
                            on: {
                                className: 'danger',
                                display: 'Rejected'
                            },
                            off: {
                                className: 'success',
                                display: 'Accepted'
                            }
                        }
                    }
                ],
                actions: []
            };
            return tableConfig;
        }

        function getPendingUsersCount() {
            return coreService.httpAccountsGet('pending/user/count').then(function (results) {
                $rootScope.$emit('updatePendingUsersBadgeCount', results.data.PendingUsersCount);
                return results.data;
            });
        }

        function rejectPendingUser(pendingUserId) {
            var url = 'pending/user/' + encodeURIComponent(pendingUserId) + '/reject';
            return coreService.httpAccountsPost(url, pendingUserId);
        }

        function processPendingUser(pendingUser) {
            return coreService.httpAccountsPost('pendingUsers', pendingUser);
        }

        function getAllPendingRolesByApplication(applicationID) {
            var query = service.getRolesODataResource().odata();
            query.filter('ApplicationId', new $odata.Value(parseInt(applicationID).toString(), 'Int32'));
            return query
                .expand('Application')
                .withInlineCount()
                .query()
                .$promise;
        }

        function getRolesForPendingUser(pendingUserId) {
            var query = service.getRolesODataResource().odata();
            query.filter('PendingUserId', new $odata.Value(parseInt(pendingUserId).toString(), 'Int32'));
            return query
                .expand('Role')
                .withInlineCount()
                .query()
                .$promise;
        }

        function getApplicationAccessAndRolesForMasterUser(userId) {
            var promises = [];
            var userApplications = [];
            var userRoles = [];

            promises.push(
                userApplicationService.getUserApplicationsByUser(userId).then(function (results) {
                    if (results.length) {
                        userApplications = results;
                        return userApplications;
                    }
                })
            );

            promises.push(
                userRoleService.getUserRolesByUser(userId).then(function (results) {
                    if (results.length) {
                        userRoles = results;
                        return userRoles;
                    }
                })
            );

            // loop over applications above and merge into one array
            return $q.all(promises).then(function () {
                var mergedAppsWithRoles = [];
                angular.forEach(userApplications, function (app) {
                    var ismerged = false;
                    var appWithNoRoles = {
                        RoleId: null,
                        ApplicationId: app.ApplicationId,
                        RoleName: ''
                    };

                    angular.forEach(userRoles, function (role) {
                        if (role.Role.ApplicationId === app.ApplicationId) {
                            var appWithRoles = angular.copy(appWithNoRoles);
                            appWithRoles.RoleId = role.Role.RoleId;
                            appWithRoles.RoleName = role.Role.RoleName;

                            mergedAppsWithRoles.push(appWithRoles);
                            ismerged = true;
                        }
                    });

                    if (!ismerged) {
                        mergedAppsWithRoles.push(appWithNoRoles);
                    }
                });

                return $q.when(mergedAppsWithRoles);
            });
        }       
    }
})();
